module.exports = __webpack_public_path__ + "img/brand_4.639ad776.png";